/* RGB quantity-aware headline for standard Dawn product templates.
   Multi-buy selector and PixelGlow manage their own prices and are excluded.
   Shopify variant prices are authoritative; we do not edit the cart or variant ID. */
(() => {
  const isSpecial = (root) =>
    root.matches('.prismtide-page, .rgb-pixelglow-pdp') ||
    Boolean(root.querySelector('[data-rgb-multibuy], [data-rgb-pg-single-variants]')) ||
    Boolean(document.querySelector('[data-rgb-multibuy-bridge]'));

  const install = (root) => {
    if (root.dataset.rgbStandardPriceInstalled === '1' || isSpecial(root)) return;
    const quantity = root.querySelector('.product-form__quantity input[name="quantity"]');
    const priceRoot = root.querySelector('[id^="price-"]');
    if (!quantity || !priceRoot) return;
    const firstPrice = priceRoot.querySelector('.price[data-rgb-price-unit-cents]');
    if (!firstPrice || firstPrice.dataset.rgbPriceHasVolumeBreaks === 'true') return;
    root.dataset.rgbStandardPriceInstalled = '1';

    const format = (cents, currency, showCode) => {
      try {
        const result = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(cents / 100);
        return showCode && !result.includes(currency) ? result + ' ' + currency : result;
      } catch (_) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    };
    const originalCodeShown = /(?:^|\s)[A-Z]{3}(?:\s|$)/.test(firstPrice.textContent || '');

    const render = () => {
      if (isSpecial(root)) return;
      const holder = root.querySelector('[id^="price-"]');
      const price = holder?.querySelector('.price[data-rgb-price-unit-cents]');
      const qtyField = root.querySelector('.product-form__quantity input[name="quantity"]');
      if (!price || !qtyField || price.dataset.rgbPriceHasVolumeBreaks === 'true') return;
      const unit = Number.parseInt(price.dataset.rgbPriceUnitCents, 10);
      const compare = Number.parseInt(price.dataset.rgbPriceCompareCents, 10) || 0;
      const currency = price.dataset.rgbPriceCurrency || window.Shopify?.currency?.active || 'GBP';
      const count = Number.parseInt(qtyField.value, 10) || 1;
      if (!Number.isSafeInteger(unit) || unit < 0 || count < 1) return;
      const sum = unit * count;
      if (!Number.isSafeInteger(sum)) return;
      const onSale = compare > unit;
      const formatted = format(sum, currency, originalCodeShown);
      const regular = holder.querySelector('.price__regular .price-item--regular');
      const sale = holder.querySelector('.price__sale .price-item--last');
      const crossed = holder.querySelector('.price__sale s.price-item--regular');
      if (regular) regular.textContent = formatted;
      if (sale) sale.textContent = formatted;
      if (crossed && onSale) crossed.textContent = format(compare * count, currency, originalCodeShown);
      price.classList.toggle('price--on-sale', onSale);

      let caption = holder.querySelector('[data-rgb-standard-price-caption]');
      if (!caption) {
        caption = document.createElement('p');
        caption.className = 'rgb-standard-quantity-price-caption';
        caption.setAttribute('data-rgb-standard-price-caption', '');
        holder.appendChild(caption);
      }
      caption.hidden = count < 2;
      caption.textContent = count < 2 ? '' :
        'Total for ' + count + ' items · ' + format(unit, currency, originalCodeShown) + ' each';
    };

    root.addEventListener('input', (event) => {
      if (event.target?.matches?.('.product-form__quantity input[name="quantity"]')) render();
    });
    root.addEventListener('change', (event) => {
      if (event.target?.matches?.('.product-form__quantity input[name="quantity"]')) render();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
        if (data?.sectionId && root.dataset.section && String(data.sectionId) !== String(root.dataset.section)) return;
        window.requestAnimationFrame(() => { if (root.isConnected) render(); });
      });
    }
    render();
  };

  const init = () => document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
})();